﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    aVarighet: undefined,
    bVerdensdel: undefined,
    cLand: undefined,
    dSkolepenger: undefined,
    eUniversitet: undefined,
    visUtbetalingsplan: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aVarighet) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            default:
                return state;
        }
    }
}
